import React, {useState} from "react";
import CrossChain from "../crossChain/crossChain";
import useWindowSize from "../../../hooks/useWindowSize";
// import Wallet from "../wallet/wallet";
//Image
// import LogoKDG from '../asset/images/logo-img.svg';
import WagmiConnect from "../wagmi-connect";

const Header = ({openMenuSp}) => {
    const [isOpenMenuSP, setIsOpenMenuSP] = useState(false);
    const size = useWindowSize();
    const sizeTablet = 1024;

    if(size.width <= sizeTablet) {
        return (
            <div className="c-header">
                <div className="c-header__logo"></div>
                <div className={`c-header__toggle ${isOpenMenuSP ? 'is-open' : ''}`} onClick={() => {setIsOpenMenuSP(!isOpenMenuSP); openMenuSp(!isOpenMenuSP)}}>
                    <span></span>
                </div>
            </div>
        );
    }
    return(
        <div className="c-header">
            {/* <Wallet /> */}
            <WagmiConnect />
            <CrossChain />
        </div>
    );
};

export default Header;